import { NgModule } from '@angular/core';
import { IonCleaveDirective } from './ion-cleave.directive';

@NgModule({
  imports: [],
  declarations: [IonCleaveDirective],
  exports: [IonCleaveDirective],
})
export class IonCleaveDirectiveModule {
}
